import { SessionStorageService } from "../services/SessionStorageService";

export const initSessionStorageSequenceId = (): void => {
	const sessionStorageService = SessionStorageService.getInstance();
	if (sessionStorageService.isAvailable()) {
		const sessionStorageSequenceId = sessionStorageService.getItem("sequenceId");
		if (sessionStorageSequenceId === null) sessionStorageService.setItem("sequenceId", "0");
	}
};

export const getSessionStorageSequenceId = (): number => {
	const sessionStorageService = SessionStorageService.getInstance();
	return sessionStorageService.isAvailable() ? Number(SessionStorageService.getInstance().getItem("sequenceId")) : -1;
};

export const increaseSequenceId = (): void => {
	// value in session storage always string
	const sessionStorageService = SessionStorageService.getInstance();
	if (sessionStorageService.isAvailable()) {
		SessionStorageService.getInstance().setItem("sequenceId", (getSessionStorageSequenceId() + 1).toString());
	}
};
